<section class="invoice-reminder-form">
  <app-form-header [menuDefinition]="menuDefinition" (onCancel)="cancel()"></app-form-header>
  @if (form) {
    <form class="invoice-reminder-form__form astral-content-width astral-stack-l" [formGroup]="form">
      <section class="astral-section-surface astral-stack-m">
        <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
          <astral-input [span]="2" [control]="form.controls['contactName']"></astral-input>
          <astral-input [control]="form.controls['companyName']"></astral-input>
          <app-money-box [control]="form.controls['invoiceTotalAmount']"></app-money-box>
          <app-money-box [control]="form.controls['invoiceUnPaidAmount']"></app-money-box>
        @if (hasOcr) {
            <astral-input [control]="form.controls['ocr']"></astral-input>
        }
          <astral-input [control]="form.controls['deliveryMethod']"></astral-input>
          <astral-input [control]="form.controls['emailDeliveryStatusText']"></astral-input>
          <astral-date-picker
            [control]="form.controls['sentDate']"
            [model]="LocalDate.fromDate(dataContext.sentDate)"
            [label]="'COMMON.SENT'"
            [readonly]="true"
          ></astral-date-picker>
          <astral-date-picker
            [control]="form.controls['createdDate']"
            [model]="LocalDate.fromDate(dataContext.createdDate)"
            [label]="'PAYMENT.DATE'"
            [readonly]="true"
          ></astral-date-picker>
          <astral-date-picker
            [control]="form.controls['dueDate']"
            [model]="dataContext.invoiceDueDate"
            [label]="'INVOICE.DUE_DATE'"
            [readonly]="true"
          ></astral-date-picker>
        </astral-layout-group>
      </section>

      <section class="astral-section-surface astral-stack-m">
        <h4>{{ 'INVOICE.REMINDER_GUARANTOR_INFORMATION' | translate }}</h4>
          <app-list-view
            [columnDefinition]="columnDefinitions"
            [itemsSource]="dataContext.guarantorReminders"
            [preferencesKey]="'invoice-reminder.guarantor-reminders'"
          ></app-list-view>
      </section>
    </form>
  }
</section>
